"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("ethers/utils");
// @TODO ethers v5 has an isAddress function
exports.isAddress = (address) => {
    try {
        utils_1.getAddress(address);
    }
    catch (_a) {
        return false;
    }
    return true;
};
